import { useEffect, useRef, useState } from 'react';

interface UseTableOfContentsReturn {
    activeHeader: string | null;
}

export const useTableOfContents = (content: string): UseTableOfContentsReturn => {
    const [activeHeader, setActiveHeader] = useState<string | null>(null);
    const observerRef = useRef<IntersectionObserver>();

    useEffect(() => {
        if (observerRef.current) observerRef.current.disconnect();

        if ('IntersectionObserver' in window) {
            const observerOptions = {
                root: null,
                rootMargin: '0px 0px -80% 0px',
                threshold: 0,
            };

            const observerCallback = (entries: IntersectionObserverEntry[]): void => {
                entries.forEach((entry) => {
                    const targetId = entry.target.getAttribute('id');
                    if (entry.isIntersecting && targetId) {
                        setActiveHeader(targetId);
                    }
                });
            };

            observerRef.current = new IntersectionObserver(observerCallback, observerOptions);

            const headers = document.querySelectorAll('h2, h3');

            headers.forEach((header) => {
                if (header) {
                    if (observerRef.current) observerRef.current.observe(header);
                }
            });
        }

        return () => {
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, [content]);

    return { activeHeader };
};
